import React, { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { MIND_PATTERNS_DATA_AREAS, MIND_PATTERNS_DATA_REPORTS } from '../../../core/constants';
import { getMindPatternsDataById } from '../../../core/mind-patterns';
import { getTeamMemberById, teamsMemberActions } from '../../../core/teams-members';

const WorkingWhithVaks = ({ teamId, userId }) => {
  const dispatch = useDispatch();
  const teamMemberData = useSelector(state => getTeamMemberById(state, userId));
  const member = teamMemberData?.member;
  const reports = useSelector(state => getMindPatternsDataById(state, MIND_PATTERNS_DATA_REPORTS));
  const mindPatternsAreas = useSelector(state => getMindPatternsDataById(state, MIND_PATTERNS_DATA_AREAS));

  useEffect(() => {
    if (!member?.user_id && !member?.isLoading) {
      dispatch(teamsMemberActions.fetchTeamMemberById({ teamsMemberId: userId, teamId }));
    }
  }, [])

  if (!member) return null;

  const currentReport = reports?.items?.find?.(report => report.code === member.mind_pattern);
  const defaultTextReport = currentReport?.feature_summary || '';

  if (!member.mind_pattern) return null;

  const mind_patterns = member.mind_pattern.split("").map((mp, k) => {
    const area = mindPatternsAreas?.items?.find(mpArea => { return mpArea.code.toLowerCase() === mp.toLowerCase() });

    return (
      <div key={`${k}_${mp}`} className="text-center">
        <div className={`mb-1 mx-auto rounded-circle mind-pattern-area ${area.code !== 'A' ? 'text-white' : ''} bg-${area.name.toLowerCase()}`} style={{ width: '42px', height: '42px' }}>
          <img className={area.code !== 'A' ? 'img-brightness' : ''}
            src={area.icon}
            alt={area.name} />
        </div>
        <div>
          <small className='font-weight-semibold'>
            {area.name}
          </small>
        </div>
      </div>
    );
  });

  return (
    <Fragment>
      <div className="d-flex justify-content-around gap-10 mb-3">
        {mind_patterns}
      </div>
      <div>
        <p>{member.mind_pattern_info || defaultTextReport}</p>
      </div>
    </Fragment>
  );
};

export default WorkingWhithVaks;
